import { createAction } from '@reduxjs/toolkit';
import {
  CreateRoleRequest,
  GetRolesByPartnerNameResponse,
  GetRolesListResponseWithPagination,
  RoleResponse,
  RoleWithPermissionsResponse,
} from 'features/admin-roles/api/types';

export const adminRolesActions = {
  clearAdminRolesList: createAction(
    '[admin_roles]CLEAR_ERRORS_ADMIN_ROLES_STATE'
  ),
  getAdminRolesListRequest: createAction<{
    page: number;
    limit: number;
    selectedPermission?: number;
  }>('[admin_roles]GET_ADMIN_ROLES_LIST_REQUEST'),
  getAdminRolesListSuccess: createAction<GetRolesListResponseWithPagination>(
    '[admin_roles]GET_ADMIN_ROLES_LIST_SUCCESS'
  ),
  getAdminRolesListFailure: createAction<string[]>(
    '[admin_roles]GET_ADMIN_ROLES_LIST_FAILURE'
  ),
  getAdminRolesByPartnerNameRequest: createAction<{ partnerName?: string }>(
    '[admin_roles]GET_ADMIN_ROLES_BY_PARTNER_NAME_REQUEST'
  ),
  getAdminRolesByPartnerNameSuccess:
    createAction<GetRolesByPartnerNameResponse>(
      '[admin_roles]GET_ADMIN_ROLES_BY_PARTNER_NAME_SUCCESS'
    ),
  getAdminRolesByPartnerNameFailure: createAction<string[]>(
    '[admin_roles]GET_ADMIN_ROLES_BY_PARTNER_NAME_FAILURE'
  ),
  createRoleRequest: createAction<CreateRoleRequest>(
    '[admin_roles]CREATE_ROLE_REQUEST'
  ),
  createRoleSuccess: createAction<RoleResponse>(
    '[admin_roles]CREATE_ROLE_SUCCESS'
  ),
  createRoleFailure: createAction<string[]>('[admin_roles]CREATE_ROLE_FAILURE'),

  getRoleRequest: createAction<{ roleId: number }>(
    '[admin_roles]GET_ROLE_REQUEST'
  ),
  getRoleSuccess: createAction<RoleWithPermissionsResponse>(
    '[admin_roles]GET_ROLE_SUCCESS'
  ),
  getRoleFailure: createAction<string[]>('[admin_roles]GET_ROLE_FAILURE'),

  updateRoleRequest: createAction<CreateRoleRequest & { roleId: number }>(
    '[admin_roles]UPDATE_ROLE_REQUEST'
  ),
  updateRoleSuccess: createAction<RoleResponse>(
    '[admin_roles]UPDATE_ROLE_SUCCESS'
  ),
  updateRoleFailure: createAction<string[]>('[admin_roles]UPDATE_ROLE_FAILURE'),

  deleteRoleRequest: createAction<{ roleId: number }>(
    '[admin_roles]DELETE_ROLE_REQUEST'
  ),
  deleteRoleSuccess: createAction<number>('[admin_roles]DELETE_ROLE_SUCCESS'),
  deleteRoleFailure: createAction<string[]>('[admin_roles]DELETE_ROLE_FAILURE'),

  deleteRolesRequest: createAction<number[]>(
    '[admin_roles]DELETE_ROLES_REQUEST'
  ),
  deleteRolesSuccess: createAction<number[]>(
    '[admin_roles]DELETE_ROLES_SUCCESS'
  ),
  deleteRolesFailure: createAction<string[]>(
    '[admin_roles]DELETE_ROLES_FAILURE'
  ),
};
